import { roundTo, log } from './math';

const primeBases = [ 2, 3, 5, 7 ];
const lowChanges = [ -2, -1, 1, 2 ]

interface Form {
  base: number;
  power: number;
  change: number;
}

export const listForms = (num: number, bases = primeBases, changes = lowChanges) => {
  const forms: Form[] = [];
  for (const base of bases) {
    for (const change of changes) {
      const power = roundTo(log(num + change, base), 7);
      
      if (power > 1 && Number.isInteger(power)) {
        forms.push({
          base,
          power,
          change: -change
        });
      }
    }
  }
  return forms;
}